import { Injectable, Inject } from '@angular/core';
import { LearningTrack } from '../shared/models';

export interface LearningTracksPage {
  tracks: LearningTrack[];
  currentPage: number;
  totalPages: number;
  totalCount: number;
}

@Injectable({ providedIn: 'root' })
export class AcademyCatalogService {
  constructor(
    @Inject('CourseTrackService') private CourseTrackService: any,
    @Inject('UserService') private UserService: any,
  ) {}

  async getLearningTracks(page: number = 1, perPage: number = 6): Promise<LearningTracksPage> {
    const response = await this.CourseTrackService.learningTracks(page, perPage);

    return {
      tracks: response.data as LearningTrack[],
      currentPage: parseInt(response.headers('X-Page') || '1'),
      totalPages: parseInt(response.headers('X-Total-Pages') || '1'),
      totalCount: parseInt(response.headers('X-Total') || '0'),
    };
  }

  /** Admins are never locked by course order, matching the API. */
  async isCurrentUserAdmin(): Promise<boolean> {
    try {
      const response = await this.UserService.me();
      return response?.data?.user_type === 'admin';
    } catch {
      return false;
    }
  }

  async getAllLearningTracks(): Promise<LearningTrack[]> {
    const response = await this.CourseTrackService.learningTracks(1, 100);
    return response.data as LearningTrack[];
  }
}
